const menuData = {

  "Cricket": [
    { id: 1, name: "Cricket Shoes", subCategory: "Gear" },
    { id: 2, name: "Cricket Stumps", subCategory: "Equipment" },
    { id: 3, name: "Bat Grip", subCategory: "Accessories" },
    { id: 4, name: "Cricket Helmet", subCategory: "Protective Gear" },
    { id: 5, name: "Batting Gloves", subCategory: "Protective Gear" },
    { id: 6, name: "Cricket Matting", subCategory: "Ground Equipment" },
    { id: 7, name: "Batting Tee", subCategory: "Training" }
  ],

  "Team Sports": [
    { id: 8, name: "Football", subCategory: "Balls" },
    { id: 9, name: "Football Net", subCategory: "Accessories" },
    { id: 10, name: "Volleyball", subCategory: "Balls" },
    { id: 11, name: "Volleyball Net", subCategory: "Accessories" },
    { id: 12, name: "Volleyball Pole/Post", subCategory: "Equipment" },
    { id: 13, name: "Throwball", subCategory: "Balls" },
    { id: 14, name: "Handball", subCategory: "Balls" },
    { id: 15, name: "Shooting Ball", subCategory: "Balls" },
    { id: 16, name: "Kho-Kho Pole", subCategory: "Traditional Sports" }
  ],

  "Athletics": [
    { id: 17, name: "Javelin", subCategory: "Field Events" },
    { id: 18, name: "Shot Put", subCategory: "Field Events" },
    { id: 19, name: "Discus (Steel Rim)", subCategory: "Field Events" },
    { id: 20, name: "Relay Baton", subCategory: "Track Events" },
    { id: 21, name: "High Jump Stand", subCategory: "Equipment" }
  ],

  "Boxing": [
    { id: 22, name: "Boxing Gloves", subCategory: "Protective Gear" },
    { id: 23, name: "Boxing Bag", subCategory: "Training Equipment" },
    { id: 24, name: "Boxing Head Guard", subCategory: "Protective Gear" },
    { id: 25, name: "Mouth Guard", subCategory: "Protective Gear" }
  ],

  "Fitness": [
    { id: 26, name: "Gym Gloves", subCategory: "Accessories" },
    { id: 27, name: "Skipping Rope", subCategory: "Cardio" },
    { id: 28, name: "Rubber Dumbbells", subCategory: "Weights" },
    { id: 29, name: "Yoga Mat", subCategory: "Yoga" },
    { id: 30, name: "Hula Hoop", subCategory: "Fitness Tools" }
  ],

  "Traning": [
    { id: 31, name: "Agility Ladder", subCategory: "Speed Training" },
    { id: 32, name: "Speed Hurdles", subCategory: "Speed Training" },
    { id: 33, name: "Training Hurdle (Adjustable)", subCategory: "Training" },
    { id: 34, name: "Plastic Cone", subCategory: "Training Accessories" },
    { id: 35, name: "Saucer Cone", subCategory: "Training Accessories" },
    { id: 36, name: "Height Measuring Stand", subCategory: "Equipment" }
  ],

  "Indoor Games": [
    { id: 37, name: "Carrom Board", subCategory: "Board Games" },
    { id: 38, name: "Carrom Stand", subCategory: "Board Games" },
    { id: 39, name: "Chess Board", subCategory: "Board Games" },
    { id: 40, name: "Tennekoit Ring", subCategory: "Ring Games" }
  ],

  "Accessories": [
    { id: 41, name: "Swimming Jacket", subCategory: "Swimming" },
    { id: 42, name: "Swimming Kit", subCategory: "Swimming" },
    { id: 43, name: "Skating Shoes", subCategory: "Skating" },
    { id: 44, name: "Helmet (Cycling/Skating)", subCategory: "Protective Gear" },
    { id: 45, name: "Trophy", subCategory: "Awards" },
    { id: 46, name: "Wooden Lazium", subCategory: "Traditional Equipment" },
    { id: 47, name: "Steel Lazium", subCategory: "Traditional Equipment" },
    { id: 48, name: "Tug of War Rope", subCategory: "Outdoor Games" },
    { id: 49, name: "Tennis Racket", subCategory: "Rackets" },
    { id: 50, name: "Badminton Racket", subCategory: "Rackets" },
    { id: 51, name: "Ghungru Kathi", subCategory: "Traditional Equipment" }
  ],

  "Boys Shoes": [
    { id: 52, name: "Sports Running Shoes", subCategory: "Footwear" },
    { id: 53, name: "Cricket Shoes", subCategory: "Footwear" },
    { id: 54, name: "Football Studs", subCategory: "Footwear" },
    { id: 55, name: "Casual Sneakers", subCategory: "Footwear" },
    { id: 56, name: "Training Shoes", subCategory: "Footwear" }
  ],

  "Boys Clothes":[
    { id: 57, name: "Sports Running Shoes", subCategory: "Footwear" },
    { id: 58, name: "Cricket Shoes", subCategory: "Footwear" },
    { id: 59, name: "Football Studs", subCategory: "Footwear" },
    { id: 60, name: "Casual Sneakers", subCategory: "Footwear" },
    { id: 61, name: "Training Shoes", subCategory: "Footwear" },
    { id: 62, name: "Training Shoes", subCategory: "Footwear" }



  ],

  "Jersey": [
    { id: 63, name: "Cricket Jersey", subCategory: "Sportswear" },
    { id: 64, name: "Football Jersey", subCategory: "Sportswear" },
    { id: 65, name: "Basketball Jersey", subCategory: "Sportswear" },
    { id: 66, name: "Training T-Shirt", subCategory: "Sportswear" },
    { id: 67, name: "Custom Team Jersey", subCategory: "Sportswear" }
  ]



};

export default menuData;